<template>
<nav class="navbar navbar-inverse">
<div class="container-fluid">
    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="mobile-navbar-collapse">
      <ul class="nav navbar-nav">
        <li v-for="(link, text) in navigation"  v-bind:key="text">
          <router-link  v-on:click.native="toggleNavbar" :to="link">{{text}}</router-link>
        </li>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->
</nav>
</template>

<script>
export default {  
  name: 'MobileNav',
  props: ['navigation'],
  methods: {
    toggleNavbar: function() {
      // eslint-disable-next-line
      $("#mobile-navbar-collapse").collapse('toggle');
    }
  }
}
</script>

<style>
.basic-mobile-menu .navbar {
  min-height: 0px;
  margin-bottom: 0px;
}
#custom-toggle span.icon-bar {
	border-bottom: 1px solid black;
}
#mobile-navbar-collapse {
	background-color: black;
  border-radius: 2px;
}
nav.navbar-inverse {
	background-color: transparent;
	border: 0px;
}
.navbar-nav {
  padding: 0px;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 6px;
  padding-bottom: 6px;
}
.nav.navbar-nav li a {
  border-bottom: 1px solid rgba(255,255,255,0.25);
  margin-left: 12px;
  margin-right: 12px;
  padding-left: 0px;
  padding-right: 0px;
  text-transform: capitalize;
}
.nav.nav.navbar-nav li:last-child a{
  border-bottom: 0px;
}
</style>